import React from "react";
import MovieArcSite from "../components/site/siteinfo.js";
import CheckIfMobile from "../functions/checkmobile.js";

export default function PromoAndMood() {
  return (
    <div className = "personalChoice">
        <CheckIfMobile />
        <MovieArcSite/>
    </div>
  );
}